<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสินค้า
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row
          ><v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ชื่อสินค้า') }"
          >
            <label>{{ $t('ชื่อสินค้า') }}</label>
            <input
              :data-vv-as="$t('ชื่อสินค้า')"
              v-validate="'required'"
              v-model="input.product_name"
              class="form-control"
              type="text"
              name="ชื่อสินค้า"
            />
            <span class="text-error" v-if="errors.has('ชื่อสินค้า')">{{
              errors.first('ชื่อสินค้า')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('SKU') }">
            <label>{{ $t('SKU') }}</label>
            <input
              :data-vv-as="$t('SKU')"
              v-validate="'required'"
              v-model="input.sku"
              class="form-control"
              type="text"
              name="SKU"
            />
            <span class="text-error" v-if="errors.has('SKU')">{{ errors.first('SKU') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Mat code') }"
          >
            <label>{{ $t('Mat code') }}</label>
            <input
              :data-vv-as="$t('Mat code')"
              v-validate="'required'"
              v-model="input.material_code"
              class="form-control"
              type="text"
              name="Mat code"
            />
            <span class="text-error" v-if="errors.has('Mat code')">{{
              errors.first('Mat code')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('departmentStore') }"
          >
            <label>{{ $t('ห้าง') }}</label>
            <input
              :data-vv-as="$t('ห้าง')"
              v-validate="'required'"
              v-model="input.department_store"
              class="form-control"
              type="text"
              name="departmentStore"
            />
            <span class="text-error" v-if="errors.has('departmentStore')">{{
              errors.first('departmentStore')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('department_store_id') }"
          >
            <label>{{ $t('รหัสของห้าง') }}</label>
            <input
              :data-vv-as="$t('รหัสของห้าง')"
              v-validate="'required'"
              v-model="input.department_store_id"
              class="form-control"
              type="text"
              name="department_store_id"
            />
            <span class="text-error" v-if="errors.has('department_store_id')">{{
              errors.first('department_store_id')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('คะแนนที่ได้') }"
          >
            <label>{{ $t('คะแนนที่ได้') }}</label>
            <input
              :data-vv-as="$t('คะแนนที่ได้')"
              v-validate="'required'"
              v-model="input.points"
              class="form-control"
              type="number"
              name="คะแนนที่ได้"
            />
            <span class="text-error" v-if="errors.has('คะแนนที่ได้')">{{
              errors.first('คะแนนที่ได้')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('price') }">
            <label>{{ $t('ราคา') }}</label>
            <input
              :data-vv-as="$t('ราคา')"
              v-validate="'required'"
              v-model="input.price"
              class="form-control"
              type="number"
              name="price"
            />
            <span class="text-error" v-if="errors.has('price')">{{ errors.first('price') }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        department_store_id: '', // รหัสสาขาของ toa
        department_store: '', // ห้าง

        product_name: '', // ชื่อสินค้า
        sku: '',
        material_code: '',
        price: '',
        points: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    editbranch() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.editproducttoacrm(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.createproducttoacrm(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ProductEdit.vue